/*eslint-disable */
angular.module('dental')
	.config(['$translateProvider', 'URL_PREFIX', ($translateProvider, URL_PREFIX) => {
		$translateProvider
			.preferredLanguage(window && window.language || 'en')
			// .fallbackLanguage('en')
			.useSanitizeValueStrategy('sce')
			.useLoader('$translatePartialLoader', {
				urlTemplate: URL_PREFIX + '/assets/i18n/{lang}/{part}.json'
			});
	}]);
/*eslint-enable */